const getters = {
    note: (state) => state.note,
    id: (state) => state.id,
    notebyleadid: (state) => state.notebyleadid,
    loading: state => state.loading
};

export default getters;